<template>
    <OvertimeRequestList :activeTabIndex="0" title="Pending" />
</template>

<script>
import OvertimeRequestList from "./overtime-request-list.vue"
export default { components: { OvertimeRequestList } }
</script>
